import React from "react";
import MarketingLayout from "../components/MarketingLayout";
import { BRAND } from "../data/brand";

const EFFECTIVE = "1 January 2025";
function H2({ children }) { return <h2 style={{ fontSize: 18, fontWeight: 700, color: "#dde6f0", margin: "36px 0 10px" }}>{children}</h2>; }
function P({ children })  { return <p style={{ fontSize: 14, color: "#6b7e94", lineHeight: 1.85, margin: "0 0 14px" }}>{children}</p>; }
function Li({ children }) { return <li style={{ fontSize: 14, color: "#6b7e94", lineHeight: 1.85, marginBottom: 6 }}>{children}</li>; }

export default function RefundPolicy() {
  return (
    <MarketingLayout>
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "64px 24px 80px" }}>
        <div style={{ fontSize: 10, color: "#3b82f6", letterSpacing: 2, fontWeight: 800, marginBottom: 10, fontFamily: "'JetBrains Mono',monospace" }}>LEGAL</div>
        <h1 style={{ fontSize: "clamp(24px,4vw,36px)", fontWeight: 800, color: "#dde6f0", marginBottom: 8 }}>Refund Policy</h1>
        <p style={{ fontSize: 12, color: "#2a3a4a", marginBottom: 40 }}>Effective date: {EFFECTIVE} · {BRAND.company}</p>

        <P>We want you to be satisfied with DPL Jade. This policy describes when refunds are available and how to request one.</P>

        <H2>7-Day Money-Back Guarantee</H2>
        <P>If you are not satisfied with a new Pro or Team subscription, you may request a full refund within <strong style={{ color: "#dde6f0" }}>7 calendar days</strong> of your first payment, provided:</P>
        <ul style={{ paddingLeft: 20, margin: "0 0 14px" }}>
          <Li>You have not synced more than 3 projects to our cloud backend, and</Li>
          <Li>You have not generated more than 5 PDF exports under the paid plan.</Li>
        </ul>
        <P>To request a refund, email <a href={`mailto:${BRAND.email}`} style={{ color: "#3b82f6" }}>{BRAND.email}</a> with subject line <em>"Refund Request — [your registered email]"</em> within the 7-day window. Refunds are processed back to the original payment method within 5–7 business days.</P>

        <H2>Renewals</H2>
        <P>Automatic renewal charges are generally non-refundable. If you did not intend to renew, contact us within <strong style={{ color: "#dde6f0" }}>48 hours</strong> of the renewal charge and we will review the request on a case-by-case basis.</P>

        <H2>Annual Plans</H2>
        <P>Annual plan payments are refundable (pro-rated for unused months) only in cases of extended service outages exceeding 72 hours that are directly attributable to our infrastructure. Standard cancellations of annual plans are not eligible for pro-rated refunds.</P>

        <H2>Exceptions</H2>
        <P>No refunds are issued for:</P>
        <ul style={{ paddingLeft: 20, margin: "0 0 14px" }}>
          <Li>Requests made after the 7-day window.</Li>
          <Li>Accounts suspended or terminated due to violation of our Terms of Use.</Li>
          <Li>Dissatisfaction with cost estimates generated by the software (these are indicative — see our Disclaimer).</Li>
        </ul>

        <H2>How to Cancel</H2>
        <P>To cancel your subscription and avoid future charges, go to your Account Settings → Subscription → Cancel. Cancellation takes effect at the end of your current billing period; you retain access until then.</P>

        <H2>Contact</H2>
        <P>{BRAND.company}<br />
          Email: <a href={`mailto:${BRAND.email}`} style={{ color: "#3b82f6" }}>{BRAND.email}</a>
        </P>
      </div>
    </MarketingLayout>
  );
}
